import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { cfaVersionList } from "../../redux/actions/cfaAction";
import "../products/productDetail.css";
import CFAVersionHistoryTableData from "./cfa-version-history-table-data";
import DownArrow from "../../assets/filterArrowDown.svg";
import UpArrow from "../../assets/filterArrowUp.svg";
import LoadingSpinnerTable from "../../components/utilites/loader";
import { useNavigate } from "react-router-dom";
import NumberPagination from "../../components/Pagination/number-pagination";

const CFAVersionHistoryTable = ({ search, page_no, status }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [cfaVersionListData, setCfaVersionListData] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(
      cfaVersionList(
        {
          search,
          page,
          status:
            status === "active" ? true : status === "inactive" ? false : null,
        },
        onSuccess,
        onError
      )
    );
  }, [search, page, status]);

  const onSuccess = (data) => {
    setLoading(false);
    setCfaVersionListData(data.data.data);
  };

  const onError = (err) => {
    setLoading(false);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table">
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"4%"}>
                  #
                </th>
                <th className="table-heads " width={"10%"}>
                  CFA ID
                </th>
                <th className="table-heads " width={"10%"}>
                  CFA Name
                </th>
                <th className="table-heads " width={"10%"}>
                  CFA Depot Manager Name
                </th>
                <th className="table-heads " width={"8%"}>
                  Updated By
                </th>
                <th className="table-heads " width={"10%"}>
                  Updated Date
                </th>
                <th
                  ref={componentRef}
                  className="table-heads text-nowrap"
                  width={"8%"}
                >
                  <span
                    className={
                      openStatus
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                    onClick={() => {
                      setOpenStatus(!openStatus);
                    }}
                  >
                    <span className={status ? "Medium_Purple fw_700" : ""}>
                      Status
                    </span>
                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" />
                    )}
                  </span>
                  {openStatus ? (
                    <div className=" position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="active"
                            name="status"
                            value={"active"}
                            checked={status === "active"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/cfa/version-history?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=active`
                              );
                            }}
                          />
                          <label
                            htmlFor="active"
                            className={
                              status === "active"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Active
                          </label>
                        </div>
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="inactive"
                            name="status"
                            value={"inactive"}
                            checked={status === "inactive"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/cfa/version-history?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=inactive`
                              );
                            }}
                          />
                          <label
                            htmlFor="inactive"
                            className={
                              status === "inactive"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Inactive
                          </label>
                        </div>
                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setOpenStatus(!openStatus);
                            navigate(
                              `/cfa/version-history?page=1${
                                search ? `&search=${search}` : ""
                              }`
                            );
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : null}
                </th>
                <th className="table-heads " width={"10%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : cfaVersionListData?.cfa?.length > 0 ? (
                <>
                  {cfaVersionListData?.cfa?.map((eachRow, index) => (
                    <CFAVersionHistoryTableData
                      key={eachRow.id}
                      data={eachRow}
                      index={index}
                      currentPage={cfaVersionListData?.pagination?.currentPage}
                    />
                  ))}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {cfaVersionListData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={cfaVersionListData?.pagination?.currentPage}
              totalPages={cfaVersionListData?.pagination?.totalPages}
              path={"/cfa/version-history"}
              filters={`${queryString}`}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default CFAVersionHistoryTable;
const data = [
  {
    id: "1",
    cfaId: "CFA1234567",
    cfaName: "CFA Name Goes Here",
    firmName: "Firm Name Goes Here",
    updatedBy: "Admin1",
    updatedDate: "23 sep 2022, 7:33 PM",
    status: "Active",
    actions: {
      view: "view",
      edit: "edit",
      disable: "disable",
    },
  },
  {
    id: "2",
    cfaId: "CFA12345698",
    cfaName: "CFA Name Goes Here",
    firmName: "Firm Name Goes Here",
    updatedBy: "Admin1",
    updatedDate: "22 sep 2022, 7:36 PM",
    status: "Active",
    actions: {
      view: "view",
      edit: "edit",
      disable: "disable",
    },
  },
  {
    id: "3",
    cfaId: "CFA1234569",
    cfaName: "CFA Name Goes Here",
    firmName: "Firm Name Goes Here",
    updatedBy: "Admin1",
    updatedDate: "24 sep 2022, 7:33 PM",
    status: "Inactive",
    actions: {
      view: "view",
      edit: "edit",
      disable: "disable",
    },
  },
  {
    id: "4",
    cfaId: "CFA1234567",
    cfaName: "CFA Name Goes Here",
    firmName: "Firm Name Goes Here",
    updatedBy: "Admin1",
    updatedDate: "25 sep 2022, 7:33 PM",
    status: "Active",
    actions: {
      view: "view",
      edit: "edit",
      disable: "disable",
    },
  },
];
